// import JA from '@tellus/ui/lib/locale/lang/ja'
import { generateMessages } from '../utils'

// auto load app language message files
const modules = require.context('./ja', true, /\.json$/)

export default {
  ...generateMessages(modules, 'ja'),
  // ...JA
}
